(ns ycweb.app.website.myaccount.orders.list
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

;; Components ===================================================================================================================

;; Order line
(rum/defc order-line [app-atom new-cart? client-order]
  (let [{:client-order/keys
         [deliveries date-placed id for-registry-order-id receiver-name
          total-price status-class status-text order-type qty]} client-order]
    [:tr.yc-tr
     {:key (:ent/uuid client-order)}
     [:th.yc-th {:scope "row" :data-th "Order No."} (:ent/display-name client-order)]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Date"}
       [:span.yc-td__faux-td
        [:span.clip-date.unclip-date--t.clip-date--ma.unclip-date--l
         {:data-date (ud/date-format (ud/coerce-date date-placed) "dd MMM YYYY")}
         [:span.clip-date__text (ud/date-format (ud/coerce-date date-placed) "dd MMM YYYY")]]]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Shipped To"}
       [:span.yc-td__faux-td
        (when for-registry-order-id
          [:span "Registry" [:span.clip-name.unclip-name--t.clip-name--ma.unclip-name--l " Recipient"]]) receiver-name]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Amount"}
       [:span.yc-td__faux-td "R" (u/currency-format total-price)]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Status"}
       [:span.yc-td__faux-td
        {:class (str "text-status--" status-class)}
        (if (and (contains? #{"Delivered" "Collected"} status-text) for-registry-order-id (> for-registry-order-id 0))
          [:a.text-link.js-mfp-open-url
           {:href "/help.htm?action=article&id=43"
            :class (str "text-status--" status-class)
            :target_url "/help.htm?action=article&id=43&overrideincludes=blank"
            :data-content-wrapper-class "yc-simple-text"}
           "For Registry"]
          status-text)]]]

     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Delivery"}
       [:span.yc-td__faux-td
        (when (and (not= "Cancelled" status-text) (not-empty deliveries))
          (map
            (fn [d]
              (let [{delivery-uuid :ent/uuid
                     :delivery/keys [date-delivered company-name emailed-order-shipped tracking-url waybill-number]} d]
                [:span
                 {:key delivery-uuid}
                 (if date-delivered
                   [:span.clip-text.unclip-text--t.clip-text--ma.unclip-text--l (ud/date-format (ud/coerce-date date-delivered) "dd MMM YYYY")]

                   (cond
                     (= company-name "Ready for Collection")
                     (if (and (= emailed-order-shipped 0) (not (contains? #{"Delivered" "Collected"} status-text)))
                       [:a.text-link.js-mfp-open-url {:target_url "/help.htm?action=article&id=29&name=Order-Collections&overrideincludes=blank" :data-title= "<b>Order</b> Collections" :data-content-wrapper-class= "yc-simple-text" :href (str "yuppiechef.com/help.htm?action=article&id=29&name=Order-Collections")} "Await Notification"]
                       "To Collect")

                     (and
                       (= order-type "Shop")
                       (= company-name "By Hand"))
                     "Store Sale"

                     :else
                     company-name))

                 (when
                   (and tracking-url waybill-number)
                   [:span (str " - ") [:a.text-link {:href (str tracking-url waybill-number) :target "_blank"} "Track"]])

                 [:br]]))
            deliveries))]]]
     [:td
      {:class (u/bem :yc-td [:centered])}
      [:span.yc-td__faux-table {:data-th "Options"}
       [:span.yc-td__faux-td
        ;TODO: Update ID to UUID
        (cond
          ;;Abandoned/Inactive Carts are not shown in my account anymore, so this case won't be hit.
          ;;Not supporting set cart in SPA
          (and (contains? #{"Abandoned Cart" "Inactive Cart"} status-text) (> qty 0))
          [:a.text-link
           {:href (str "/myaccount.htm?action=setcart&orderid=" id)}
           "Checkout"]

          (= status-text "Order Placed")
          (if new-cart?
            [:a.text-link
             {:href
              (str "/order.htm?action=ShowCart"
                "&step=payment%2Fmethod-postcheckout"
                "&orderid=" id
                "&h=" (:client-order/hash client-order))}
             "Pay"]
            [:a.text-link
             {:href (str "/order.htm?action=paymentoptions&id=" id "&h=" (:client-order/hash client-order) "&ref=myaccount")}
             "Pay"])

          :else
          [:a.text-link (urlstate/href-props app-atom "myaccount" "trackview" {:uuid (:ent/uuid client-order)})
           "View"])]]]]))

;; Order table
(rum/defc order-history < rum/reactive [app-atom orders]
  (let [orderlist-settings-atom (rum/cursor-in app-atom [:myaccount :orderlist])
        new-cart? (cmn/curact app-atom [:features :new-cart])

        {:keys [pages]} (rum/react orderlist-settings-atom)

        pagecount (u/ceil (/ (count orders) (:pagesize pages 10)))]

    (when (> (or (:page pages) 0) pagecount)
      (swap! orderlist-settings-atom assoc-in [:pages :page] 1))

    [:div
     (headings/heading "Order History" {:type :h2 :size :medium})

     (cond
       (> (count orders) 0)
       [:div
        [:table.yc-table
         {:id :orderlist}
         [:caption.yc-table-caption.hidden-from-view "View your most recent orders"]
         [:thead.yc-thead
          [:tr.yc-tr
           [:th.yc-th {:scope "col"} "Order" [:span.clip-text.unclip-text--l " No."]]
           [:th.yc-th {:scope "col"} "Date" [:span.clip-text.unclip-text--l " Placed"]]
           [:th.yc-th {:scope "col"} "Shipped" [:span.clip-text.unclip-text--l " To"]]
           [:th.yc-th {:scope "col"} "Amount"]
           [:th.yc-th {:scope "col"} "Status"]
           [:th.yc-th {:scope "col"} "Order" [:span.clip-text.unclip-text--l " Info"]]
           [:th
            {:class (u/bem :yc-th [:centered])
             :scope "col"}
            "Options"]]]

         (into
           [:tbody.yc-tbody]
           (map (partial order-line app-atom new-cart?)
             (->>
               orders
               (drop (* (- (:page pages 1) 1) (:pagesize pages 10)))
               (take (:pagesize pages 10)))))]
        (web-common/pagination-control app-atom (rum/cursor orderlist-settings-atom :pages) pagecount {:scroll-to "orderlist"})]

       :else
       [:div.no-data-wrapper.yc-section.yc-section--standard
        [:div.no-data-view
         [:p "You don't have any past orders."]
         [:div.button-wrapper.button-wrapper--align-center
          (buttons/button-web "Start shopping"
            {:href "/index.htm"
             :style :dark})]]])

     (toaster/loading-overlay app-atom :web.myaccount/orderslist)]))

(rum/defc orders < rum/reactive [app-atom]
  (let [state (rum/react (cmn/action-cursor app-atom))]
    (order-history app-atom (:order-history state))))

;; Routing ===================================================================================================================

(defmethod comms/receive :web.myaccount/orders [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/orderslist)
  (swap! (cmn/action-cursor app-atom) assoc
    :order-history (:order-history e)))

(defmethod t/transition-open :web.myaccount/orders [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/orderslist)
  (comms/ajax-get :web.myaccount/orders {}))

(defmethod flow/render-screen :web.myaccount/orders [app-atom _]
  (awm.common/screen-wrapper app-atom
    [:div.dashboard
     (orders app-atom)]))
